<!-- 
<div class="container-fluid p-h-0 p-v-20 h-100 bg" style="background-image: url('assets/images/others/login-3.png')">
    <div class="d-flex flex-column justify-content-between h-100">
        <div class="d-none d-md-block"></div>
        <div class="container font-poppins">
            <div class="row align-items-center">
                <div class="col-md-7 col-lg-5 m-h-auto">
                    <nz-card class="m-b-100 shadow-lg">
                        <div class="d-flex align-items-center m-b-30">
                            <img class="img-fluid" alt="" src="assets/images/logo/_equip.png">
                        </div>
                        <form nz-form [formGroup]="loginForm" nzLayout="vertical" class="login-form" (ngSubmit)="submitForm()" >
                            <nz-form-item>
                                <nz-form-label nzRequired nzFor="Email" class="font-16"><span
                                        class="font-16">Email</span></nz-form-label>
                                <nz-form-control>
                                    <nz-input-group [nzPrefix]="prefixUser">
                                        <input type="text" nz-input formControlName="Email" placeholder="Email">
                                    </nz-input-group>
                                    <nz-form-explain style="color: #de4436"
                                        *ngIf="loginForm.controls.Email.errors?.required && loginForm.controls.Email.touched">
                                        Please enter your Email!</nz-form-explain>
                                    <nz-form-explain style="color: #de4436"
                                        *ngIf="!loginForm.controls.Email.errors?.required && loginForm.controls.Email.touched && loginForm.controls.Email.errors?.email">
                                        Invalid Email.</nz-form-explain>
                                </nz-form-control>
                            </nz-form-item>
                            <nz-form-item>
                                <nz-form-label nzRequired nzFor="password" class=""><span
                                        class="font-16">Password</span>
                                </nz-form-label>
                                <nz-form-control>
                                    <nz-input-group [nzPrefix]="prefixLock" [nzSuffix]="suffixTemplate">
                                        <input type="password" [type]="passwordVisible ? 'text' : 'password'"
                                            nz-input formControlName="Password" placeholder="Password">
                                    </nz-input-group>
                                    <nz-form-explain style="color: #de4436"
                                        *ngIf="loginForm.get('Password').dirty && loginForm.get('Password').errors">
                                        Please enter your Password!</nz-form-explain>
                                </nz-form-control>
                            </nz-form-item>

                            <nz-form-item style="float: right">
                                <nz-form-control>
                                    <div class="d-flex align-items-center justify-content-between">
                                        <button nz-button class="login-form-button"
                                            [disabled]="loginForm.invalid===true" [nzType]="'primary'"><span
                                                class="font-16">Sign In</span></button>
                                    </div>
                                </nz-form-control>
                            </nz-form-item>
                        </form>
                        <ng-template #prefixUser><i nz-icon nzType="user"></i></ng-template>
                        <ng-template #prefixLock><i nz-icon nzType="lock"></i></ng-template>
                        <ng-template #suffixTemplate><i nz-icon [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
                            (click)="passwordVisible = !passwordVisible"></i></ng-template>
                    </nz-card>
                </div>
            </div>
        </div>
        <div class="d-none d-md-flex p-h-40 justify-content-between">
            <span class="">© 2022 Noritz</span>
        </div>
    </div>
</div>



 -->
 <ng2-toasty [position]="'top-right'"></ng2-toasty>
 <div class="container-fluid p-h-0 p-v-20 h-100 bg" style="background-image: url('assets/images/others/login-3.png')">
 <!-- <lib-ng-toast></lib-ng-toast> -->
     <div class="d-flex flex-column justify-content-between h-100">
         <div class="d-none d-md-block"></div>
         <div class="container font-poppins">
             <div class="row align-items-center">
                 <div class="col-md-7 col-lg-5 m-h-auto">
                     <nz-card class="m-b-100 shadow-lg">
                         <div class="d-flex align-items-center m-b-30">
                             <img class="img-fluid" alt="" src="assets/images/logo/_equip.png">
                         </div>
                         <form nz-form [formGroup]="loginForm" nzLayout="vertical" class="login-form" (ngSubmit)="submitForm()" >
                             <nz-form-item>
                                 <nz-form-label nzRequired nzFor="Email" class="font-16"><span
                                         class="font-16">Email</span></nz-form-label>
                                 <nz-form-control>
                                     <nz-input-group [nzPrefix]="prefixUser">
                                         <input type="text" nz-input formControlName="Email" placeholder="Email">
                                     </nz-input-group>
                                     <nz-form-explain style="color: #de4436"
                                         *ngIf="loginForm.controls.Email.errors?.required && loginForm.controls.Email.touched">
                                         Please enter your Email</nz-form-explain>
                                     <nz-form-explain style="color: #de4436"
                                         *ngIf="!loginForm.controls.Email.errors?.required && loginForm.controls.Email.touched && loginForm.controls.Email.errors?.email">
                                         Invalid Email.</nz-form-explain>
                                 </nz-form-control>
                             </nz-form-item>
                             <nz-form-item>
                                 <nz-form-label nzRequired nzFor="password" class=""><span
                                         class="font-16">Password</span>
                                 </nz-form-label>
                                 <nz-form-control>
                                     <nz-input-group [nzPrefix]="prefixLock" [nzSuffix]="suffixTemplate">
                                         <input type="password" [type]="passwordVisible ? 'text' : 'password'"
                                             nz-input formControlName="Password" placeholder="Password">
                                     </nz-input-group>
                                     <nz-form-explain style="color: #de4436"
                                         *ngIf="loginForm.get('Password').dirty && loginForm.get('Password').errors">
                                         Please enter your Password</nz-form-explain>
                                 </nz-form-control>
                             </nz-form-item>
 
                             <nz-form-item style="float: right">
                                 <nz-form-control>
                                     <div class="d-flex align-items-center justify-content-between">
                                         <button nz-button class="login-form-button"
                                             [disabled]="loginForm.invalid===true" [nzType]="'primary'" [nzLoading]="isLogin"><span
                                                 class="font-16">Sign In</span></button>
                                     </div>
                                 </nz-form-control>
                             </nz-form-item>
                         </form>
                         <ng-template #prefixUser><i nz-icon nzType="user"></i></ng-template>
                         <ng-template #prefixLock><i nz-icon nzType="lock"></i></ng-template>
                         <ng-template #suffixTemplate><i nz-icon [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
                             (click)="passwordVisible = !passwordVisible"></i></ng-template>
                     </nz-card>
                 </div>
             </div>
         </div>
         <div class="d-none d-md-flex p-h-40 justify-content-between">
             <span class="">© 2022 Noritz</span>
             <!-- <ul class="list-inline">
                 <li class="list-inline-item">
                     <a class="text-dark text-link" href="">Legal</a>
                 </li>
                 <li class="list-inline-item">
                     <a class="text-dark text-link" href="">Privacy</a>
                 </li>
             </ul> -->
         </div>
     </div>
 </div>